import styled from 'styled-components';

import { HOME, SPACE, WEBSITE_ANALYTICS } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** A card on the overview card: the inner panel fill (as the trend chart's), no outline; `$sunken` sets it into a
 *  darker recessed well instead (the sign-up figures, apart from the traffic ones above). */
export const Tile = styled.div<{ $sunken: boolean }>`
  background: ${(p) => (p.$sunken ? WEBSITE_ANALYTICS.sunkenTile : HOME.panel)};
  border-radius: 16px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  padding: ${SPACE[16]};
`;

export const Label = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  color: ${HOME.t300};
`;

export const Figure = styled.div`
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  color: ${HOME.t50};
`;

export const ChangeRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACE[8]};
  min-height: 22px;
`;

export const Caption = styled(Text)`
  font-size: 12px;
  color: ${HOME.t500};
`;

export const Hint = styled(Text)`
  font-size: 13px;
  line-height: 1.4;
  color: ${HOME.t400};
`;
